import $ from "jquery";
import "slick-carousel/slick/slick";

$(document).ready(function () {
  var numSlides = $(".hero-image-container").length;
  var initialSlide = Math.round(numSlides * Math.random());

  var images = $("#hero-images");
  images.on("init", function (event, slick, direction) {
    // Hint at other images, and avoid occasional hidden (opacity=0) image on first load
    slick.slickNext();
  });

  images.slick({
    initialSlide: initialSlide,
    autoplay: true,
    autoplaySpeed: 6000,
    easing: "swing",
    fade: true,
    speed: 1500,
    mobileFirst: true,
    dots: false,
    arrows: false
  });
});



// WEBPACK FOOTER //
// ./hero/windsorpc-hero.js